import TotalMetric from '@/Enums/ReportingDashboard/TotalMetric.enum';
import TotalSlide from '@/components/TotalSlide';
import { liftPercentToDisplay, numberToUsFormat } from '@/helpers/valueFormatter/numberFormatter.helpers';
import { useAppSelector } from '@/store/hooks';
import { selectFootTrafficTotals } from '@/store/selectors/attribution/footTraffic.selectors';
import FootTrafficImpressionsTotals from './FootTrafficImpressionsTotals';
import TotalsCardHeader from './TotalsCardHeader';

const TotalStoreVisitsTooltipHeader =
  'Represents the total measured foot traffic visits, filtered by location, date, advertiser, and campaign.';

const AvgWeeklyUniqueVisitorsTooltipHeader =
  'Estimated unique people per week, averaged across the weeks in the selected range. Placer counts uniques per location per week, so someone visiting several selected locations in one week is counted once per location.';

const FootTrafficTotalsCard = () => {
  const { totals, loading } = useAppSelector(selectFootTrafficTotals);

  return (
    <div className='col-span-4 grid grid-cols-2 md:grid-cols-3 gap-[20px] print:gap-[10px]'>
      <FootTrafficImpressionsTotals />
      <TotalSlide
        metric={TotalMetric.FootTrafficVisits}
        value={totals[TotalMetric.FootTrafficVisits]}
        label={<TotalsCardHeader label='Total Store Visits' tooltipValue={TotalStoreVisitsTooltipHeader} />}
        loading={loading}
      />
      <TotalSlide
        metric={TotalMetric.YoyPercentChange}
        value={totals[TotalMetric.YoyPercentChange]}
        label={
          <TotalsCardHeader
            label='YoY % Change'
            tooltipValue='Year-over-year change in visits — current period vs. the same period one year ago.'
          />
        }
        valueConverter={v => liftPercentToDisplay(v, true)}
        loading={loading}
      />
      <TotalSlide
        metric={TotalMetric.TwoYearBaselineChange}
        value={totals[TotalMetric.TwoYearBaselineChange]}
        label={
          <TotalsCardHeader
            label='vs. 2-Year Baseline'
            tooltipValue='Change in visits vs. the same period two years ago.'
          />
        }
        valueConverter={v => liftPercentToDisplay(v, true)}
        loading={loading}
      />
      <TotalSlide
        metric={TotalMetric.AvgWeeklyUniqueVisitors}
        value={totals[TotalMetric.AvgWeeklyUniqueVisitors]}
        label={
          <TotalsCardHeader label='Avg Weekly Unique Visitors' tooltipValue={AvgWeeklyUniqueVisitorsTooltipHeader} />
        }
        valueConverter={v => numberToUsFormat(v)}
        loading={loading}
      />
    </div>
  );
};

export default FootTrafficTotalsCard;
